import { ROLES } from '@/shared/constants/roles';

export const coursegenRoutes = [
  {
    path: 'aide',
    name: 'aide',
    component: () => import('./views/CourseContentGenView.vue'),
    meta: {
      requiredRole: ROLES.INSTRUCTOR,
    },
  },
];
